import React from "react";
import ReactPaginate from "react-paginate";
import { PrevSvg } from "../../../svgFiles/PrevSvg";
import { NextSvg } from "../../../svgFiles/NextSvg";
import useTranslator from "../../../hooks/useTranslator";
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const { _t } = useTranslator();

  return (
    <div className="pagination">
      <ReactPaginate
        breakLabel="..."
        nextLabel={
          <>
            {_t("next", "Next")} <NextSvg />
          </>
        }
        onPageChange={(event) => onPageChange(event.selected + 1)}
        pageRangeDisplayed={5}
        pageCount={totalPages}
        previousLabel={
          <>
            <PrevSvg /> {_t("prev", "Prev")}
          </>
        }
        forcePage={currentPage - 1} 
        renderOnZeroPageCount={null}
        activeClassName="active-page"
        previousClassName="previous-page"
        nextClassName="next-page"
        disabledClassName="disabled-page"
      />
    </div>
  );
};

export default Pagination;
